import {
  ChoicesProps,
  DateInput,
  DeleteWithConfirmButton,
  Edit,
  SaveButton,
  SelectInput,
  SimpleForm,
  TextInput,
  Toolbar,
  useDataProvider
} from 'react-admin';
import {USER_STATUS_CHOICES} from "../../constants/user-status";
import {useEffect, useState} from "react";
import {ExtendedDataProvider} from "../../utils/data-provider";
import {DictionaryCollection, DictionaryType} from "../../types/dictionary-collection";
import {ClientApiResponse} from "../../types/http-client";

const CustomToolbar = () => {

  return (
    <>
      <Toolbar style={{justifyContent: 'end', gap: '1rem'}}>
        <DeleteWithConfirmButton/>
        <SaveButton mutationOptions={{}}/>
      </Toolbar>
    </>
  );
};

export const UserEdit = () => {
  const dataProvider = useDataProvider<ExtendedDataProvider>();
  const [genderChoices, setGenderChoices] = useState<ChoicesProps['choices']>([]);

  useEffect(() => {
    dataProvider
      .customMethod(`/dictionary?types=${DictionaryType.GENDER}`)
      .then(({ data }) => {
        const res = data as ClientApiResponse<DictionaryCollection>;
        const options = res.data[DictionaryType.GENDER]?.map(item => {
          return {
            id: item.value,
            name: item.label,
          }
        });
        setGenderChoices(options)
      })
      .catch((e) => {
        console.error('Failed to load status options:', e);
        setGenderChoices([]);
      });
  }, [dataProvider]);

  return (
    <Edit>
      <SimpleForm  toolbar={<CustomToolbar />}>
        <TextInput source="email"/>
        <TextInput source="name" />
        <TextInput source="lastName" />
        <SelectInput
          source="gender"
          choices={genderChoices}
        />
        <SelectInput
          source="status"
          choices={USER_STATUS_CHOICES}
        />
        <DateInput source="createdAt" disabled />
      </SimpleForm>
    </Edit>
  );
}
